import React from "react";
import { Custom, Modal } from "components";
import { useApp } from "context";
import { useForm } from "hooks";
import { useNavigate } from "react-router-dom";
import { Constants, Enums, Helpers, Routes } from "utils";

export const SignUp = () => {
  const { t, setFeedback, setUser, service } = useApp();
  const navigate = useNavigate();

  const initialState = {
    firstName: "",
    lastName: "",
    email: "",
    dob: "",
    password: "",
  };

  const { onChange, onSubmit, values } = useForm(submitCallback, initialState);

  async function submitCallback() {
    const { firstName, lastName, email, dob, password }: any = values;
    if (checkboxConsent) {
      if (Helpers.hasValue(firstName, lastName, email, dob, password)) {
        if (Helpers.validatePasswordPolicy(password)) {
          const [status, response] = await service.auth.signup(values as any);
          if (status === Enums.EnumResponse.Success) {
            const { password, ...rest }: any = values;
            setFeedback(null);
            setUser({ ...rest, active: null });
            navigate(Routes.auth.accountVerification);
          } else if (status === Enums.EnumResponse.Forbidden) {
            setFeedback({
              message: t.message.auth.email_taken,
              severity: Enums.EnumFeedback.Error,
            });
          } else if (status === Enums.EnumResponse.BadRequest) {
            setFeedback({
              message: t.message.feedback.required_fields,
              severity: Enums.EnumFeedback.Info,
            });
          }
        } else {
          setFeedback({
            message: t.message.auth.password_invalid,
            severity: Enums.EnumFeedback.Error,
          });
        }
      } else {
        setFeedback({
          message: t.message.feedback.required_fields,
          severity: Enums.EnumFeedback.Info,
        });
      }
    } else {
      setFeedback({
        message: t.message.auth.consent_required,
        severity: Enums.EnumFeedback.Info,
      });
    }
  }

  const [checkboxConsent, setCheckboxConsent] = React.useState(false);

  const [consentModal, setConsentModal] = React.useState(false);
  const handleConsentOpen = () => setConsentModal(true);
  const handleConsentClose = (state: boolean) => {
    setCheckboxConsent(state);
    setConsentModal(false);
  };

  const handleCheckboxChange = (
    _: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setCheckboxConsent(checked);
    // if (checked) handleConsentOpen();
  };

  return (
    <>
      <form onSubmit={onSubmit} className="qh-form">
        <Custom.TextField
          name="firstName"
          required={true}
          onChange={onChange}
          label={t.label.first_name}
        />
        <Custom.TextField
          name="lastName"
          required={true}
          onChange={onChange}
          label={t.label.last_name}
        />
        <Custom.TextField
          name="dob"
          mask={Constants.INPUT_MASK.DATE}
          required={true}
          label={t.label.dob}
          onChange={onChange}
        />
        <Custom.TextField
          name="email"
          type="email"
          required={true}
          onChange={onChange}
          label={t.label.email}
        />
        <Custom.TextField
          type="password"
          name="password"
          required={true}
          onChange={onChange}
          label={t.label.password}
        />
        <Custom.Checkbox
          name="consent"
          required={true}
          checked={checkboxConsent}
          onChange={handleCheckboxChange}
          label={Helpers.interpolate(t.message.auth.consent, {
            tac: t.label.tac,
            privacy_policy: t.label.privacy_policy,
          })}
        />
        <div className="qh-control">
          <Custom.Button
            tabIndex={-1}
            variant="outlined"
            href={Routes.auth.signin}
          >
            {t.action.sign_in}
          </Custom.Button>
          <Custom.Button submit>{t.action.sign_up}</Custom.Button>
        </div>
      </form>
      <Modal.Consent opened={consentModal} onClose={handleConsentClose} />
    </>
  );
};
